export default {
  data() {
    return {
      mandatOfferConst: [
        {label: 'Premium', value: 'OFFER1'},
        {label: 'Essentielle', value: 'OFFER3'},
        {label: 'Confort', value: 'OFFER2'},
        {label: this.$t('undefined'), value: undefined},
      ],
    };
  },
  methods: {
    displayForMandatOfferConst(value) {
      let result = this.mandatOfferConst.find((el) => el.value === value);
      return result ? result.label : '';
    },
  },
};
